import { tExtendedCompanyWithCounts } from "../../types";
import "../../css/UserEditModal.css";
import "../../css/SiteAdminModals.css";

interface ModuleActivationModalProps {
    isOpen: boolean;
    onClose: () => void;
    company: tExtendedCompanyWithCounts | null;
    onToggleModule: (companyId: string, moduleField: string, value: boolean) => void;
}

const UNIQUE_MODULES = [
    { field: "initialStarterPackageEnrollment", name: "Inspections", desc: "Equipment inspection forms & reports" },
    { field: "pmModuleEnrollment", name: "Preventive Maintenance", desc: "PM scheduling & service records" },
    { field: "tiresModuleEnrollment", name: "Tire Maintenance", desc: "Tire inventory, assignment & tracking" },
    { field: "costTrackingModuleEnrollment", name: "Cost Tracking", desc: "Expense categories & cost reports" },
    { field: "trainingModuleEnrollment", name: "Safety / Training", desc: "Safety topics, compliance tracking" },
    { field: "skillTrackingModuleEnrollment", name: "User Skillsets", desc: "Employee qualifications tracking" },
];

export const ModuleActivationModal = ({ isOpen, onClose, company, onToggleModule }: ModuleActivationModalProps) => {
    if (!isOpen || !company) return null;

    return (
        <div className="uem-overlay" onClick={onClose}>
            <div className="uem-modal" onClick={(e) => e.stopPropagation()}>
                <div className="uem-header">
                    <h2>Module Activation — {company.name}</h2>
                    <button className="uem-close" onClick={onClose} aria-label="Close modal">×</button>
                </div>
                <div className="uem-body">
                    <p className="uem-modal-desc">
                        Active modules appear on the company's home page. Inactive modules are visible but locked until activated.
                    </p>
                    <div className="uem-toggle-grid">
                        {UNIQUE_MODULES.map(({ field, name, desc }) => {
                            const isActive = !!(company as Record<string, unknown>)[field];
                            return (
                                <div key={field} className={`uem-toggle-card ${isActive ? "active" : ""}`}>
                                    <div className="uem-toggle-card-info">
                                        <div className="uem-toggle-card-name">{name}</div>
                                        <div className="uem-toggle-card-desc">{desc}</div>
                                    </div>
                                    <label className="uem-toggle-switch">
                                        <input
                                            type="checkbox"
                                            checked={isActive}
                                            onChange={() => onToggleModule(company.id, field, !isActive)}
                                        />
                                        <span className="uem-toggle-slider" />
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="uem-footer">
                    <button type="button" className="uem-btn-cancel" onClick={onClose}>Cancel</button>
                    <button type="button" className="uem-btn-submit" onClick={onClose}>Save Module Access</button>
                </div>
            </div>
        </div>
    );
};
